/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/folder'
export default icon
